import { render, staticRenderFns } from "./InstructorCheckboxes.vue?vue&type=template&id=0aa2f86e&scoped=true"
import script from "./InstructorCheckboxes.vue?vue&type=script&lang=js"
export * from "./InstructorCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./InstructorCheckboxes.vue?vue&type=style&index=0&id=0aa2f86e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa2f86e",
  null
  
)

export default component.exports